const FORM_FIELDS_TYPE = {
  TOGGLE: 'toggle',
  TEXT: 'text',
  SELECT: 'select',
  CHECKBOX: 'checkbox',
  NUMBER: 'number',
  EMAIL: 'email',
  GROUP_TEXT: 'groupTextField',
  ARRAY_LIST: 'arrayString',
  BANNER: 'banner',
  RADIO_GROUP: 'radioGroup',
  DROP_DOWN: 'dropDown'
};

const MDM_ASSET_CLASS_IDS = {
  ANDROID: '41',
  APPLE_IOS: '42',
  APPLE_IPAD_OS: '43'
};

const MDM_POLICY_TYPES = {
  MDM_GENERAL_RESTRICTION: 'MDM General Restriction',
  MDM_APPS_RESTRICTION: 'MDM Apps Restriction',
  MDM_SECURITY_RESTRICTION: 'MDM Security Restriction',
  MDM_NETWORK_RESTRICTION: 'MDM Network Restriction',
  MDM_CLASSROOM_AND_EDUCATION_RESTRICTION:
    'MDM Classroom And Education Restriction',
  MDM_CLOUD_AND_APPLE_INTELLIGENCE_RESTRICTION:
    'MDM Cloud And Apple Intelligence Restriction',
  MDM_APPLE_PASSCODE_CONFIGURATION: 'MDM Apple Passcode Configuration',
  MDM_ANDROID_PASSWORD_CONFIGURATION: 'MDM Android Password Configuration',
  MDM_APPLE_ADE_PROFILE_CONFIGURATION: 'MDM Apple ADE Profile Configuration',
  MDM_NETWORK_CONFIGURATION: 'MDM Network Configuration',
  MDM_SYSTEM_RESTRICTION: 'MDM System Restriction',
  MDM_CONNECTIVITY_RESTRICTION: 'MDM Connectivity Restriction',
  MDM_WIFI_CONFIGURATION: 'MDM Wifi Configuration',
  MDM_PROXY_CONFIGURATION: 'MDM Proxy Configuration',
  MDM_APPLE_SOFTWARE_MANAGEMENT: 'MDM Apple Software Management',
  MDM_ANDROID_SOFTWARE_MANAGEMENT: 'MDM Android Software Management',
  SOFTWARE_MANAGEMENT: 'Software management',
  MDM_ANDROID_OS_UPDATE_CONFIGURATION: 'MDM Android OS Update Configuration',
  MDM_APPLE_OS_UPDATES: 'MDM Apple OS Updates'
};

const MDM_POLICY_SECTIONS_ID = {
  MDM_NETWORK: 'network',
  MDM_ADE_PROFILE_POLICY: 'ade_profile_policy'
};

const MDM_SUPPORTED_ENROLLMENT_TYPES = {
  BYOD: 'BYOD',
  FULLY_MANAGED: 'FULLY_MANAGED',
  SUPERVISED: 'SUPERVISED',
  UN_SUPERVISED: 'UN_SUPERVISED'
};

const MDM_ENROLLMENT_STATUS = {
  ENROLLING: 'ENROLLING',
  ENROLLED: 'ENROLLED',
  UN_ENROLLED: 'UN_ENROLLED'
};

const GOOGLE_PLAY_CONFIG = {
  IFRAME_URL: 'https://play.google.com/work/embedded/search?token=',
  SCRIPT_SRC: 'https://apis.google.com/js/api.js'
};

const ANDROID_OS_UPDATE_TYPE = {
  AUTOMATIC: 'AUTOMATIC',
  WINDOWED: 'WINDOWED'
};

const APPLE_OS_AUTOMATIC_ACTIONS = {
  ALLOWED: 'Allowed',
  ALWAYS_ON: 'AlwaysOn',
  ALWAYS_OFF: 'AlwaysOff'
};

const APPLE_OS_RECOMMENDED_CADENCE = {
  NEWEST: 'Newest',
  OLDEST: 'Oldest',
  ALL: 'All'
};

const APPLE_OS_UPDATE_ENFORCEMENT_TYPE = {
  NONE: 'NONE',
  LATEST_MINOR_UPDATE: 'LATEST_MINOR_UPDATE',
  LATEST_MAJOR_UPGRADE: 'LATEST_MAJOR_UPGRADE',
  SPECIFIC_VERSION: 'SPECIFIC_VERSION'
};

const ANDROID_ZERO_TOUCH_PORTAL_URL =
  'https://enterprise.google.com/android/zero-touch/customers/';
const ASSET_VIEW_URL = {
  ANDROID: '#/rmm/asset-view/8009',
  APPLE_IOS: '#/rmm/asset-view/8010',
  APPLE_IPAD_OS: '#/rmm/asset-view/8011',
  ENDPOINT: '#/rmm/asset-view/4001'
};

const ADE_ENROLLMENT_STATUS = {
  UN_ENROLLED: 'UN_ENROLLED',
  READY_FOR_ENROLLMENT: 'READY_FOR_ENROLLMENT',
  ENROLLED: 'ENROLLED'
};

export {
  FORM_FIELDS_TYPE,
  MDM_ASSET_CLASS_IDS,
  MDM_POLICY_TYPES,
  MDM_POLICY_SECTIONS_ID,
  MDM_SUPPORTED_ENROLLMENT_TYPES,
  MDM_ENROLLMENT_STATUS,
  GOOGLE_PLAY_CONFIG,
  ANDROID_OS_UPDATE_TYPE,
  APPLE_OS_AUTOMATIC_ACTIONS,
  APPLE_OS_RECOMMENDED_CADENCE,
  APPLE_OS_UPDATE_ENFORCEMENT_TYPE,
  ANDROID_ZERO_TOUCH_PORTAL_URL,
  ASSET_VIEW_URL,
  ADE_ENROLLMENT_STATUS
};
